<template>
  <div class="image-ambiance">
    <div class="image-ambiance__title">
      {{ document.title }}
      <div class="image-ambiance__subtitle">
        {{ document.subtitle }}
      </div>
    </div>
    <img :src="image" alt class="image-ambiance__image" />
    <div class="image-ambiance__overlay" />
    <div class="image-ambiance__copy" v-if="firstname && lastname">
      Photo by
      <a
        rel="noopener noreferrer"
        :href="
          `https://unsplash.com/@${username}?utm_source=SkipBoByJeroen&utm_medium=referral`
        "
        target="_blank"
        >{{ firstname }} {{ lastname }}</a
      >
      on
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://unsplash.com/?utm_source=SkipBoByJeroen&utm_medium=referral"
        >Unsplash</a
      >
    </div>
  </div>
</template>

<script>
import Unsplash from 'unsplash-js';
const unsplash = new Unsplash({
  accessKey: '8acd287f022c302f4450c27be199baf0789866fac48a8180c041078ccdaa883c'
});

export default {
  name: 'ImageAmbiance',
  props: { document: Object },
  data() {
    return {
      image: '',
      username: '',
      firstname: '',
      lastname: ''
    };
  },
  mounted() {
    unsplash.photos
      .getRandomPhoto({
        query: 'background abstract',
        orientation: 'landscape'
      })
      .then(result => result.json())
      .then(result => {
        this.image = result.urls.regular;
        this.username = result.user.username;
        this.firstname = result.user.first_name;
        this.lastname = result.user.last_name;
      });
  }
};
</script>

<style lang="scss" scoped>
.image-ambiance {
  position: relative;
  width: 100%;
  height: 100%;

  &__title {
    position: absolute;
    top: 20px;
    left: 20px;
    color: #fff;
    z-index: 2;
    font-weight: 700;
    font-size: 28px;
  }

  &__subtitle {
    font-weight: 600;
    font-size: 18px;
  }

  &__placeholder {
    width: 100%;
    height: 100%;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: auto;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      #000 100px,
      transparent,
      #000 calc(100% - 100px)
    );
    z-index: 1;
  }

  &__copy {
    position: absolute;
    left: 20px;
    bottom: 20px;
    font-size: 12px;
    color: #fff;
    font-weight: 600;
    z-index: 2;

    a {
      color: #fff;
      font-weight: 400;
    }
  }
}
</style>
